<template>
  <v-file-input
    :value="value"
    :filled="filled"
    :rounded="rounded"
    v-bind="$attrs"
    v-on="listeners"
    @change="handleChange"
  >
    <template
      v-for="slot of slotScopeKeys"
      #[slot]>
      <slot :name="slot"></slot>
    </template>
    <template
      v-if="isOptional"
      #label>
      {{ $attrs.label }} (ถ้ามี)
    </template>
  </v-file-input>
</template>

<script>
export default {
  name: 'BaseFileInput',
  props: {
    value: {
      type: [File, Array],
      default: undefined
    },
    filled: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    isOptional: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slotScopeKeys() {
      return Object.keys(this.$scopedSlots)
    },
    listeners() {
      const { blur, ...otherListeners } = this.$listeners
      return otherListeners
    }
  },
  methods: {
    handleChange(files) {
      this.$emit('change', files)
      if (files && files.length > 0 && this.$listeners.blur) {
        this.$listeners.blur()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-file-input ::v-deep {
  .v-input__prepend-outer .v-input__icon .v-icon {
    color: #01bb00;
  }
}

.v-file-input.v-input--is-dirty ::v-deep {
  .v-input__control .v-input__slot {
    border-color: #01bb00;
  }

  .v-input__control .v-input__slot .v-label {
    color: #01bb00;
  }

  .v-file-input__text {
    color: #01bb00;
  }

  .v-text-field__details .v-messages__message {
    color: #01bb00;
  }
}
</style>
